.fp-logo(data-test='club-logo' :class='{"-lg": lg}')
  FairplayerImageVue(:url='logoUrl' :resolution='ImageResolution.SM' :alt='t("logo.alt.club")' :fallback-image='FairplayerFallbackImageUi.LOGO')
